import apiService from '../utils/apiService';

import {
  SET_CURRENT_USER,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_ERROR,
  CHANGE_PASSWORD_START,
  SET_CURRENT_USER_START,
  SET_CURRENT_USER_ERROR,
  CLEAR_ERROR_LOGIN,
} from './types';

import {
  userChangePasswordPath,
  userLoginPath,
} from '../constants/apiEndpoints';

import setJwtToken from '../securityUtils/setJwtToken';
import { handleServerErrorMessage, handleServerSuccessMessage } from '../utils';
import { ServerMessagesEnums } from '../enums/ServerMessagesEnums';
import { ChangePasswordForm } from '../enums/ChangePasswordEnums';
var jwtDecode = require('jwt-decode');

const clearError = () => {
  return {
    type: CLEAR_ERROR_LOGIN,
  };
};

const loginUserStart = () => {
  return {
    type: SET_CURRENT_USER_START,
  };
};
const loginUserSuccessfully = (data) => {
  return {
    type: SET_CURRENT_USER,
    payload: data,
  };
};
const loginUserUnsuccessfully = (err) => {
  return {
    type: SET_CURRENT_USER_ERROR,
    payload: err,
  };
};

const changePasswordStart = () => {
  return {
    type: CHANGE_PASSWORD_START,
  };
};
const changePasswordSuccessfully = (data) => {
  return {
    type: CHANGE_PASSWORD,
    payload: data,
  };
};
const changePasswordUnsuccessfully = (err) => {
  return {
    type: CHANGE_PASSWORD_ERROR,
    payload: err,
  };
};

export const login = (loginRequest) => {
  return (dispatch) => {
    dispatch(loginUserStart());
    return apiService
      .post(userLoginPath(), loginRequest)
      .then((response) => {
        const { token, refreshToken } = response.data;
        localStorage.setItem('jwtToken', token);
        localStorage.setItem('refreshToken', refreshToken);
        setJwtToken(token);
        const decoded = jwtDecode(token);
        dispatch(loginUserSuccessfully(decoded));
      })
      .catch((err) => {
        dispatch(
          loginUserUnsuccessfully(
            err?.response?.status === 500
              ? handleServerErrorMessage(
                  ServerMessagesEnums.toastErrorMessageForServerNotAvailable
                )
              : err?.response?.data
          )
        );
      });
  };
};

export const logout = () => (dispatch) => {
  localStorage.removeItem('jwtToken');
  localStorage.removeItem('refreshToken');
  setJwtToken(false);
  window.location.href = '/';
  dispatch({
    type: SET_CURRENT_USER,
    payload: {},
  });
};

export const changePassword = (changePasswordDTO, callback) => {
  return (dispatch) => {
    dispatch(changePasswordStart());
    return apiService
      .post(userChangePasswordPath(), changePasswordDTO)
      .then((response) => {
        dispatch(changePasswordSuccessfully(response.data));
        handleServerSuccessMessage(
          ChangePasswordForm.chagePasswordSuccessMessage,
          changePasswordDTO
        );
        callback();
      })
      .catch((err) => {
        dispatch(changePasswordUnsuccessfully(err.response.data));
        handleServerErrorMessage(
          err?.response?.data?.message
            ? err?.response?.data?.message
            : err?.response?.data
        );
      });
  };
};

export const deleteErrorLogin = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};
